import React from "react";
import { Link } from "react-router-dom";

/**
 * "Complete the Set" upsell card surfaced in the cart drawer when exactly
 * one of a two-piece set is present. Suggests the missing partner with the
 * bundle saving prominently shown.
 */
export const SetUpsellCard = ({ set, partner, onClose, onAdd }) => (
  <div className="mb-5 border border-[#1a1814]/15 bg-[#f0e9e1] p-4" data-testid="cart-set-upsell">
    <div className="micro-label text-[#1a1814]/60 mb-2 text-[10px]">Complete the Set</div>
    <div className="flex items-center gap-3">
      <Link
        to={`/shop/${partner.slug}`}
        onClick={onClose}
        className="flex items-center gap-3 flex-1 group"
        data-testid={`cart-upsell-partner-${partner.id}`}
      >
        <img
          src={partner.image}
          alt={partner.name}
          style={{ objectPosition: partner.image_position || "center" }}
          className="w-12 h-14 object-cover bg-[#efe6db]"
        />
        <div className="flex-1 min-w-0">
          <div className="font-serif text-sm leading-tight group-hover:underline underline-offset-4 decoration-[0.5px]">
            {partner.name}
          </div>
          <div className="text-[10px] text-[#1a1814]/60 mt-0.5">
            Add for £{partner.price.toFixed(2)} · saves £{set.discount.toFixed(2)}
          </div>
        </div>
      </Link>
      <button
        type="button"
        onClick={() => onAdd(partner, set)}
        className="border border-[#1a1814] text-[#1a1814] px-3 py-2 micro-label text-[10px] hover:bg-[#1a1814] hover:text-[#f0e9e1]"
        data-testid={`cart-upsell-add-${partner.id}`}
      >
        Add
      </button>
    </div>
  </div>
);
